export enum ReviewPanelTab {
	REVIEW = 'review',
	HISTORY = 'history',
}
